module.exports = __webpack_public_path__ + "static/bano-cc951704db6800b145b685e179e3a6c0.jpg";